import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { ProductSizeTable } from '../../../models/product';

@Component({
  selector: 'app-product-size-table-dialog',
  imports: [MatDialogModule, MatButtonModule, MatTableModule],
  templateUrl: './product-size-table-dialog.html',
  styleUrl: './product-size-table-dialog.scss',
})
export class ProductSizeTableDialog {
  constructor(
    private dialogRef: MatDialogRef<ProductSizeTableDialog>,
    @Inject(MAT_DIALOG_DATA) private data: ProductSizeTable
  ) {}

  close(r: any = null) {
    this.dialogRef.close(r);
  }

  get titles(): string[] {
    return this.data.titles;
  }

  get values(): string[][] {
    return this.data.values;
  }
}
